import React, { useRef, useState } from "react";
import {
  Menu,
  Close,
  Dashboard,
  MoneyOff,
  Construction,
  Insights,
  List,
  ExitToApp,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useGetUserDetails, useLogout } from "../apiCalls/userApiCalls";
import useOutsideClick from "../hooks/useOutsideClick";
import { useSelector } from "react-redux";
import Loader from "./Loader";

export default function Navbar() {
  const { currentUser } = useSelector((state) => state.userSlice);
  const token = currentUser.token;
  const userId = currentUser.user._id;

  const [showUserMenu, setShowUserMenu] = useState(false);
  const userMenuRef = useRef();

  const { mutate: logoutMutate, isLoading: isLogoutLoading } = useLogout();
  const { isLoading: isUserLoading, data: userDetails } = useGetUserDetails(
    userId,
    token
  );

  useOutsideClick(userMenuRef, () => {
    if (showUserMenu) setShowUserMenu(false);
  });

  const handleLogout = () => {
    logoutMutate();
  };

  const fallbackImage = "/images/avatar.jpg";

  return (
    <>
      <nav
        className={`navbar-other px-4 card-shadow rounded-b-3xl fixed w-full z-50 bg-white top-0 hidden md:block md:px-16 lg:px-28 xl:px-28`}
      >
        <div className="items-center justify-between hidden md:flex">
          <Link to="/" className="logo ">
            <img src="/images/logo.png" alt="" className="w-24 py-4" />
          </Link>
          {isUserLoading ? (
            <Loader />
          ) : (
            <>
              <ul className="flex items-center justify-center gap-4">
                <li className="flex items-center gap-4 uppercase font-medium hover:underline underline-offset-8">
                  <Link to="/" onClick={() => setShowUserMenu(false)}>
                    Dashboard
                  </Link>
                </li>

                <li className="flex items-center gap-4 uppercase font-medium hover:underline underline-offset-8">
                  <Link to="/jobs" onClick={() => setShowUserMenu(false)}>
                    Jobs
                  </Link>
                </li>

                <li className="flex items-center gap-4 uppercase font-medium  hover:underline underline-offset-8">
                  <Link to="/nrh" onClick={() => setShowUserMenu(false)}>
                    Non-Revenue
                  </Link>
                </li>

                {userDetails?.data.data.role == "foreman" ? (
                  <li className="relative group">
                    <button className="flex items-center gap-4 uppercase font-medium">
                      Metrics
                    </button>
                    <ul className="absolute hidden group-hover:block bg-white shadow-lg rounded-lg py-2 mt-0 w-48 left-0">
                      <li className="px-4 py-2 hover:bg-gray-100">
                        <Link
                          to="/metrics"
                          onClick={() => setShowUserMenu(false)}
                          className="block w-full"
                        >
                          Overview
                        </Link>
                      </li>
                      <li className="px-4 py-2 hover:bg-gray-100">
                        <Link
                          to="/jobsList"
                          onClick={() => setShowUserMenu(false)}
                          className="block w-full"
                        >
                          Calendar View
                        </Link>
                      </li>
                    </ul>
                  </li>
                ) : (
                  <></>
                )}

                <li
                  onClick={handleLogout}
                  className="flex items-center gap-4 uppercase font-medium  hover:underline underline-offset-8"
                >
                  <Link to="/" onClick={() => setShowUserMenu(false)}>
                    {isLogoutLoading ? "Logging out..." : "Logout"}
                  </Link>
                </li>
              </ul>

              <Link to="/profile">
                <div
                  className="w-10 h-10 border border-gray-200  rounded-full"
                  style={{
                    backgroundImage: `url("${userDetails?.data.data.imgUrl}"), url("${fallbackImage}")`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
              </Link>
            </>
          )}
        </div>
      </nav>

      <nav
        className={`navbar-mbl md:hidden  z-20 px-6  pb-2 card-shadow rounded-b-3xl fixed w-full bg-white top-0`}
      >
        <div className="flex items-center justify-between">
          <Link to="/profile">
            <div
              className="w-10 h-10 border border-gray-200  rounded-full"
              style={{
                backgroundImage: `url("${userDetails?.data.data.imgUrl}"), url("${fallbackImage}")`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            ></div>
          </Link>
          <Link to="/" className="logo">
            <img src="/images/logo.png" alt="" className="w-24 py-4" />
          </Link>
          <div
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="hamburger h-10 w-10 flex items-center justify-end"
          >
            <button>
              <Menu style={{ fontSize: "25" }} />
            </button>
          </div>
        </div>
      </nav>

      <div
        ref={userMenuRef}
        className={`${
          showUserMenu ? "" : "hidden"
        } sideMenu z-30 px-6 pb-2 bg-white card-shadow fixed w-full top-0 rounded-b-3xl`}
      >
        <div className="flex items-center justify-between">
          <div className="h-10 w-10"></div>
          <Link to="/" className="logo">
            <img src="images/logo.png" alt="" className="w-24 py-4" />
          </Link>
          <div
            onClick={() => setShowUserMenu(false)}
            className="hamburger h-10 w-10 flex items-center justify-end"
          >
            <Close style={{ fontSize: "28" }} />
          </div>
        </div>
        <div className="pl-12 pt-6 pb-4">
          <Link to="/" onClick={() => setShowUserMenu(false)}>
            <div className="flex mb-1 py-1 items-center gap-4 uppercase font-medium ">
              <Dashboard style={{ fontSize: "18px" }} />
              Dashboard
            </div>
          </Link>

          <Link to="/jobs" onClick={() => setShowUserMenu(false)}>
            <div className="flex mb-1 py-1 items-center gap-4 uppercase font-medium ">
              <Construction style={{ fontSize: "18px" }} />
              Jobs
            </div>
          </Link>

          <Link to="/nrh" onClick={() => setShowUserMenu(false)}>
            <div className="flex mb-1 py-1 items-center gap-4 uppercase font-medium ">
              <MoneyOff style={{ fontSize: "18px" }} />
              Non-Revenue
            </div>
          </Link>

          {userDetails?.data.data.role == "foreman" && (
            <>
              <Link to="/metrics" onClick={() => setShowUserMenu(false)}>
                <div className="flex mb-1 py-1 items-center gap-4 uppercase font-medium ">
                  <Insights style={{ fontSize: "18px" }} />
                  Metrics Overview
                </div>
              </Link>

              <Link to="/jobsList" onClick={() => setShowUserMenu(false)}>
                <div className="flex mb-1 py-1 items-center gap-4 uppercase font-medium">
                  <List style={{ fontSize: "18px" }} /> Calendar View
                </div>
              </Link>
            </>
          )}

          <Link to="/" onClick={handleLogout}>
            <div className="flex mb-1 py-1 items-center gap-4 uppercase font-medium ">
              <ExitToApp style={{ fontSize: "18px" }} />
              {isLogoutLoading ? "Logging out..." : "Logout"}
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}
